import { gql } from '@apollo/client';
export const cloneDocumentMutation = gql `
  mutation cloneFromFileSystemDocument($id: ID!, $input: FileSystemCloneFromInsertInput!) {
    cloneFromFileSystemDocument(id: $id, input: $input) {
      id
    }
  }
`;
